export const Roles = {
    MASTER_ADMIN: 'MASTER_ADMIN',
    MERCHANT_ADMIN: 'MERCHANT_ADMIN',
    MERCHANT_USER: 'MERCHANT_USER',
  } as const;
  
  export type Role = typeof Roles[keyof typeof Roles];